<script>
export default {
  props: {
    classCustom: {
      default: () => {
        return ''
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg
    width="28"
    height="22"
    viewBox="0 0 35 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="classCustom"
  >
    <path
      d="M30.2432 12.7364L23.5662 6.06537L17.4954 0L11.4247 6.06537L4.74564 12.7398L0 17.4798L2.73229 20.2097L7.47725 15.4697L14.1576 8.79523L17.4954 5.4604L20.8332 8.79523L27.5095 15.4669L32.2586 20.2097L34.9909 17.4798L30.2432 12.7364Z"
      fill="#B7B7B7"
    />
    <path
      d="M5.8584 20.4098V30.6622H18.777V22.5381H23.4809V30.6622H29.1328V20.4064L17.497 8.78027L5.8584 20.4098Z"
      fill="#B7B7B7"
    />
  </svg>
</template>
